import { ref } from 'vue';
import { RoleQuery } from '@/services/api/resources/role/query';
import { useTask } from '@/ui/concerns';
import { list } from '@/services/api/resources/role';
import { sequence } from '@/ui/helpers';

export const useRoleCheck = () => {
  const checkLoading = ref<boolean>(true);
  const checkResult = ref<boolean>();

  const query = (): RoleQuery => ({
    search: '',
    sort: '',
    dir: '',
    page: 1,
    perPage: 1,
  });

  const performCheck = useTask(
    () => sequence(
      list(query()),
    ),
    ([
      listResponse,
    ]) => {
      checkResult.value = listResponse.data.length > 0;
      checkLoading.value = false;
    },
  );

  return {
    checkLoading,
    checkResult,
    performCheck,
  };
};
